import { Component } from '@opten/compiler/metadata/component';

declare const mixitup;

@Component({ className: 'js-filter-search' })
export class FilterSearchComponent {
	mixer: any;
	constructor(private element: HTMLElement) {
		const options = {
			itemSelector: '.js-mixitup-item',
			filterSelector: '.js-mixitup-filter',
			filterCloseSelector: '.js-mixitup-filter-close',
			filterAllClass: 'js-mixitup-filter-all',
			filterResetSelector: '.js-mixitup-filter-reset',
			filterGroupTitleSelector: '.js-mixitup-filter-group-title'
		};
		this.mixer = mixitup(element, {
			multifilter: {
				enable: true,
				minSearchLength: 1
			},
			selectors: {
				target: options.itemSelector,
				control: options.filterSelector
			},
			controls: {
				scope: 'local',
				toggleLogic: 'and'
			},
			load: {
				filter: 'none'
			},
			animation: {
				enable: false
			},
			classNames: {
				block: '',
				elementFilter: 'is',
				elementToggle: 'is'
			},
			callbacks: {
				onMixEnd: (state) => {
					if (
						state &&
						state.activeFilter &&
						state.activeFilter.selector ==
							options.itemSelector
					) {
						this.mixer.hide();
					}
				}
			}
		});
	}
}
